


























































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { AxiosResponse } from 'axios';

import User from '@/types/User';
import CollectedProduct from '@/types/CollectedProduct';
import CollectedItem from '@/types/CollectedItem';
import Amount from '@/types/Amount';

import UserAPI from '@/services/UserAPI';

export default Vue.extend({
    name: 'EditCollectedProductMobile',

    props: {
        collectedProduct: {
            type: Object as () => CollectedProduct,
            default: new CollectedProduct()
        }
	},

    data() {
		return {
			isLoading: ''
		};
	},

	computed: {
        ...mapGetters(['getLanguage', 'getCollectionSupportedLanguageCountries']),

		user(): User {
			return this.$store.state.user;
		}
	},

    methods: {
		addNewCollectedItem(collectedProduct: CollectedProduct) {
			const cloneCollectedProduct = JSON.parse(JSON.stringify(collectedProduct));
			const collectedItem = new CollectedItem();
			collectedItem.hasSticker = false;
			const amount = new Amount();
			collectedItem.purchaseAmount = amount;
			collectedItem.estimatedValueAmount = amount;
			cloneCollectedProduct.collectedItems.push(collectedItem);
			this.updateCollectedProduct(cloneCollectedProduct);
		},

		removeCollectedItem(collectedProduct: CollectedProduct, index: number) {
			collectedProduct.collectedItems.splice(index, 1);
			this.isLoading = `deleteCollectedItem${index}`;
			this.updateCollectedProduct(collectedProduct);
		},

		toogleCollectedItemSticker(collectedItem: CollectedItem): void {
			collectedItem.hasSticker = !collectedItem.hasSticker;
		},

		toogleWrapper(collectedItem: CollectedItem, productId: string, isLoading: string) {
			this.isLoading = isLoading;
			this.toogleCollectedItemSticker(collectedItem);
			this.updateCollectedProduct(this.collectedProduct);
		},

		updateCollectedProduct(collectedProduct: CollectedProduct): void {
			UserAPI
				.putCollectProduct(collectedProduct.productId, collectedProduct)
				.then((response: AxiosResponse) => {
                    if (response.data) {
                        if (!response.data.user.collectedProducts.find((cp: CollectedProduct) => cp.productId === collectedProduct.productId)) {
                            close();
                        }
                        this.$store.commit('setUser', response.data.user);
                    }
                })
				.finally(() => this.isLoading = '');
		},

        close(): void {
            this.$emit('close');
        }
	}

});
